import { Subscription } from 'rxjs';
import { DialogShared } from './../../general/shared/dialog-shared';
import { PlanShared } from 'src/app/presentation/general/shared/plan-shared';
import {
  Component,
  OnInit,
  Inject,
  ViewEncapsulation,
  ChangeDetectorRef,
  HostListener,
  OnDestroy,
} from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { BottomsheetShared } from '../../general/shared/bottomsheet-shared';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { TextHelper } from 'src/app/utils/text-helper';
import { FoodUnitRatioModel } from 'src/app/core/model/object/diet-food-model';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { DiaryAnalyticsService } from 'src/app/data/repository/analytics-repository/diary-analytics.service';
import { MatDialog } from '@angular/material/dialog';
import { PredefinedDietDialogComponent } from '../predefined-diet-dialog/predefined-diet-dialog.component';

@Component({
  selector: 'app-edit-food-bottomsheet',
  templateUrl: './edit-food-bottomsheet.component.html',
  styleUrls: ['./edit-food-bottomsheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditFoodBottomsheetComponent implements OnInit, OnDestroy {
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };

  calorie = 0;
  gram = 0;
  unit: string;
  amount: string;
  selectedRatio: string;
  ratios: string[];
  isButtonActive = true;

  showLoading = false;

  qcalorie: string = null;

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;

  isCustome: boolean = false;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<EditFoodBottomsheetComponent>,
    private bottomsheetShared: BottomsheetShared,
    private cdRef: ChangeDetectorRef,
    private planService: PlanService,
    private textHelper: TextHelper,
    private snackBarService: SnackBarService,
    private diaryAnalytics: DiaryAnalyticsService,
    private planShared: PlanShared,
    private dialog: MatDialog,
    private dialogShared: DialogShared
  ) {
    this.subscription1 =
      this.dialogShared.removeFoodContinueButtonClickObs$.subscribe(
        (clicked) => {
          if (clicked) {
            this.removeFood();
          }
        }
      );
    this.subscription2 =
      this.dialogShared.editFoodContinueButtonClickObs$.subscribe((clicked) => {
        if (clicked) {
          this.editFood();
        }
      });
    this.subscription3 = this.dialogShared.changePlanClickObs$.subscribe(
      (clicked) => {
        if (clicked) {
          this.bottomSheetRef.dismiss();
        }
      }
    );
  }

  ngOnInit() {
    if (this.data.isCustome) {
      this.qcalorie = this.data.food.calorie;
      this.isCustome = true;
    } else {
      this.initial();
    }
    console.log(this.data.food);
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
  }

  openDetail() {
    this.bottomSheetRef.dismiss();
    this.bottomSheetRef.afterDismissed().subscribe(() => {
      this.bottomsheetShared.openFoodFactBottomsheet();
    });
  }

  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.bottomSheetRef.dismiss();
    }
  }

  initial() {
    this.amount = this.data.food.amount;
    this.unit = this.data.food.unit;
    this.calculateCalorie();
    this.setFoodRatios();
  }

  calculateCalorie() {
    if (this.isCustome) {
      if (parseInt(this.qcalorie) >= 0) {
        this.isButtonActive = true;
      } else {
        this.isButtonActive = false;
      }
    } else {
      if (this.amount && this.amount !== '') {
        this.amount = this.textHelper.replacePersian(this.amount);
      }
      if (this.amount && this.amount !== '0') {
        let ratio: FoodUnitRatioModel;
        let isGram = false;
        let primaryFoodUnit = '';
        if (this.unit) {
          primaryFoodUnit = this.unit;
        } else {
          primaryFoodUnit = this.data.food.foodModel.primaryFoodUnit;
        }
        if (
          primaryFoodUnit === '' ||
          primaryFoodUnit === '5e1c595d883a966e03fb4530'
        ) {
          isGram = true;
        }
        if (isGram) {
          this.gram = -1;
          this.calorie =
            (this.data.food.foodModel.foodFact.calorieAmount *
              parseFloat(this.amount)) /
            100;
          if (parseFloat(this.amount)) {
            this.isButtonActive = true;
          } else {
            this.isButtonActive = false;
          }
        } else {
          this.data.food.foodModel.foodUnitRatioArray.forEach((r) => {
            if (r.unitId._id === primaryFoodUnit) {
              ratio = r;
            }
          });
          this.gram = ratio.ratio * parseFloat(this.amount);
          this.calorie =
            ((this.data.food.foodModel.foodFact.calorieAmount *
              parseFloat(this.amount)) /
              100) *
            ratio.ratio;
          if (parseFloat(this.amount)) {
            this.isButtonActive = true;
          } else {
            this.isButtonActive = false;
          }
        }
      } else {
        this.gram = -1;
        this.calorie = 0;
        this.isButtonActive = false;
      }
      if (parseFloat(this.amount)) {
        setTimeout(() => {
          const width = document
            .getElementById('edit-food-calorie')
            .getBoundingClientRect().width;
          document.getElementById('edit-food-name').style.width =
            'calc( 100% - 48px - ' + width.toString() + 'px )';
        }, 100);
      }
    }
  }

  setFoodRatios() {
    this.ratios = [];
    let primaryFoodUnit = '';
    if (this.unit) {
      primaryFoodUnit = this.unit;
    } else {
      primaryFoodUnit = this.data.food.foodModel.primaryFoodUnit;
    }
    if (
      primaryFoodUnit === '' ||
      primaryFoodUnit === '5e1c595d883a966e03fb4530'
    ) {
      this.selectedRatio = 'گرم';
    }
    this.data.food.foodModel.foodUnitRatioArray.forEach((r) => {
      this.ratios.push(r.unitId.name);
      if (r.unitId._id === primaryFoodUnit) {
        this.selectedRatio = r.unitId.name;
      }
    });
    this.ratios.push('گرم');
  }

  onRatioChange() {
    if (this.selectedRatio === 'گرم') {
      this.unit = '5e1c595d883a966e03fb4530';
    }
    this.data.food.foodModel.foodUnitRatioArray.forEach((r) => {
      if (r.unitId.name === this.selectedRatio) {
        this.unit = r.unitId._id;
      }
    });
    this.calculateCalorie();
  }

  editFoodCheck() {
    if (this.isCustome && this.isButtonActive) {
      const unit = '5e1c595d883a966e03fb4530';
      // this.animateButton();
      this.planService
        .editFood(unit, 0, this.data.food, parseInt(this.qcalorie))
        .then((res) => {
          if (res.isSuccess()) {
            this.diaryAnalytics.analyticDiaryPackageFoodEdited();
            this.data.food.amount = this.amount;
            this.data.food.unit = this.unit;
            this.showLoading = false;
            this.cdRef.detectChanges();
            this.bottomSheetRef.dismiss();
            this.snackBarService.showSnackBar(res.getData().getMessage());
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
            this.showLoading = false;
            this.cdRef.detectChanges();
          }
        });
    } else {
      if (this.isButtonActive) {
        if (
          this.data.isPredefined &&
          localStorage.getItem('predefined-diet-dialog') !== '1'
        ) {
          const data = {
            action: 'edit',
            dietType: this.planShared.dietType,
          };
          const dialogRef = this.dialog.open(PredefinedDietDialogComponent, {
            data,
            width: '90%',
            panelClass: 'custom-dialog-container',
          });
        } else {
          this.editFood();
        }
      }
    }
  }

  editFood() {
    const unit = this.unit
      ? this.unit
      : this.data.food.foodModel.primaryFoodUnit;
    // this.animateButton();
    this.planService
      .editFood(unit, parseFloat(this.amount), this.data.food)
      .then((res) => {
        if (res.isSuccess()) {
          this.diaryAnalytics.analyticDiaryPackageFoodEdited();
          this.data.food.amount = this.amount;
          this.data.food.unit = this.unit;
          this.showLoading = false;
          this.cdRef.detectChanges();
          this.bottomSheetRef.dismiss();
          this.snackBarService.showSnackBar(res.getData().getMessage());
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          this.showLoading = false;
          this.cdRef.detectChanges();
        }
      });
  }

  removeFoodCheck() {
    if (
      this.data.isPredefined &&
      localStorage.getItem('predefined-diet-dialog') !== '1'
    ) {
      const data = {
        action: 'remove',
        dietType: this.planShared.dietType,
      };
      const dialogRef = this.dialog.open(PredefinedDietDialogComponent, {
        data,
        width: '90%',
        panelClass: 'custom-dialog-container',
      });
    } else {
      this.removeFood();
    }
  }

  removeFood() {
    this.planService
      .removeFood(this.data.date, [this.data.food._id], true)
      .then((res) => {
        if (res.isSuccess()) {
          this.diaryAnalytics.analyticDiaryPackageFoodDeleted();
          this.bottomSheetRef.dismiss();
          this.snackBarService.showSnackBar(res.getData().getMessage());
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
      });
  }

  animateButton() {
    const button = document.getElementById('edit-button');
    button.style.width = '56px';
    button.style.right = 'calc( 50% - 28px )';
    setTimeout(() => {
      this.showLoading = true;
      this.cdRef.detectChanges();
    }, 200);
  }

  convertStringToNumber(s: string) {
    return parseFloat(s);
  }
}
